import { CommonModule, DatePipe } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';

import { ConsultaIpocPesquisaComponent } from './consulta-ipoc-pesquisa.component';
import { ConsultaIpocRoutingModule } from './consulta-ipoc-routing.module';
import { AbaTrocaIpocComponent } from './abas/troca-ipoc/aba-troca-ipoc.component';
import { AbaConsultaBacenComponent } from './abas/consulta-bacen/aba-consulta-bacen.component';



@NgModule({
  imports: [ConsultaIpocRoutingModule, SharedModule, BrowserModule, CommonModule],
  exports: [],
  declarations: [ConsultaIpocPesquisaComponent, AbaTrocaIpocComponent,AbaConsultaBacenComponent],
  providers: [DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ConsultaIpocModule { }
